var $ = window.jQuery = require('jquery');
import game_header from '../../../components/game-header/index.vue';
var id1,
  click_count = 0,
  timer1,
  id = [];
export default {
  name: 'leibniz-says-game',
  components: {
    'game-header': game_header
  },
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
    $('.routeloader').show();
    if ($('#timer').text() == '00:00') {
      $('.x').attr('draggable', 'FALSE');
      $('.num').attr('draggable', 'FALSE');
    }
    $('.box').click(function() {
      if (click_count == 1) {
        $(this).html($('#' + id[0]).html());
        $('#' + id[0]).css("color", "white");
        click_count = 0;
      }
    });
    $('.x').click(function() {
      if ($('#timer').text() != '00:00') {
        if (click_count == 0) {
          id[0] = $(this).attr('id');
          click_count = 1;
          $('#' + id[0]).css("color", "yellow");
        } else if (click_count == 1) {
          if (id[0] == $(this).attr('id')) {
            $('#' + id[0]).css("color", "white");
            id[0] = '';
          } else {
            $('#' + id[0]).css("color", "white");
            id[0] = $(this).attr('id');
            $('#' + id[0]).css("color", "yellow");
          }
        }
      }
    });
    $('.num').click(function() {
      if ($('#timer').text() != '00:00') {

        if (click_count == 0) {
          id[0] = $(this).attr('id');
          click_count = 1;
          $('#' + id[0]).css("color", "yellow");
        } else if (click_count == 1) {
          if (id[0] == $(this).attr('id')) {
            $('#' + id[0]).css("color", "white");
            id[0] = '';
          } else {
            $('#' + id[0]).css("color", "white");
            id[0] = $(this).attr('id');
            $('#' + id[0]).css("color", "yellow");
          }
        }
      }
    });
    setTimeout(() => {
      $('.routeloader').hide();
    }, 2000)
  },
  methods: {
    initDrag: function() {
      $(".x").draggable({
        revert: true,
        start: drag
      });
      $(".num").draggable({
        revert: true,
        start: drag
      });

      $(".box").droppable({
        drop: drop,
        over: Hover,
        out: dragout
      });

      function drag(ev) {
        id1 = ev.target.id;
      }

      function drop(ev) {
        $(this).css("background", "");
        $(this).css("background-color", "transparent");
        $(this).css("color", "white");
        ev.preventDefault();
        $('#' + ev.target.id).html($('#' + id1).html());
      }

      function Hover(event, ui) {
        $(this).css("background", "url(img/chalk.png");
      }

      function dragout(event, ui) {
        $(this).css("background", "");
        $(this).css("background-color", "transparent");
        $(this).css("color", "white");
      }
    },
    initGame: function() {
      $('.box').html('');
      $(".x").css("color", "white");
      $(".num").css("color", "white");
      this.startTimer();
      $('.x').attr('draggable', 'TRUE');
      $('.num').attr('draggable', 'TRUE');
      this.initDrag();
    },
    startGame: function() {
      this.initGame();
    },
    resetGame: function() {
      this.initGame();
    },
    endGame: function() {
      console.log('Game Ended');
    },
    nextLevel: function() {
      $('#result').modal('hide');
      this.$router.push('/leibniz-says/level2/#game');
    },
    startTimer: function() {
      var _self = this;
      var secs = 90;
      clearInterval(timer1);
      timer1 = setInterval(function() {
        var min = Math.floor(secs / 60);
        var rem = secs % 60;
        if (rem < 10) {
          rem = '0' + rem;
        }
        if (min < 10) {
          min = '0' + min;
        }
        $("#timer").html(min + ':' + rem);
        $("#timer1").html(min + ':' + rem);

        if (secs < 1) {
          clearInterval(timer1);
          _self.gameResult();
        }
        secs--;
      }, 1000);
    },
    gameResult: function() {
      var _self = this;
      var count = 0;
      var i;
      var message;
      var res = [];
      var j;
      var flag;
      for (i = 1; i < 6;) {

        flag = 0;
        var l = '#lbox' + i;
        var r1 = '#rbox' + i + '-1';
        var r2 = '#rbox' + i + '-2';
        res[i] = $(l).text();
        for (j = (i - 1); j > 0;) {
          if (res[i] == res[j]) flag = 1;
          j--;
        }

        if (flag != 1) {
          if (_self.calculate(l, r1, r2) == 1) {
            count++;
          }
        }
        i++;
      }

      $("#total").html(count);
      $('#points').html((count * 20));
      if (count == 0) message = "Are you serious?";
      else if (count == 1) message = "You got a long way to go, my friend";
      else if (count == 2) message = "You are getting there!";
      else if (count == 3) message = "Never Give Up, Try Again!";
      else if (count == 4) message = "You got that winning Spirit!";
      else if (count == 5) message = "You Have Aced It!";

      if (count == 5) {
        $("#resultBody h1").html('Congratulations!');
        $("#again").hide();
        $("#next-level").show();
      } else {
        $("#resultBody h1").html('Game Over!');
      }
      $('#says').html(message);
      $('#result').modal('show');
      $('.box').html('');
      $('.x').css("color", "white");
      $('.num').css("color", "white");
      $('.x').attr('draggable', 'FALSE');
      $('.num').attr('draggable', 'FALSE');
    },
    calculate: function(l, r1, r2) {
      var res1 = $(l).text();
      var res2 = $(r1).text();
      var res3 = $(r2).text();

      if (res1 == 'x') {
        res1 = 'x1';
      }
      if (res2 == "*" && res3 == "1") {
        res2 = 1;
        res3 = 'x0';
      } else if (res2 == "1" && res3 == "*") {
        res3 = 'x0';
      } else if (res3 == 'x') {
        res3 = 'x1';
      }
      if ((res1[0] != 'x') && (res1[0] != '*')) {
        if ((res2 == '*' && res3 == 0) || (res2 == 0 && res3 == '*')) {
          return 1;
        }
      } else if ((res1[1] == res2) && (res3 == 'x' + (res1[1] - 1))) {
        return 1;
      } else {
        return 0;
      }
    }
  },
  beforeCreate: function() {
    $('body').addClass('leibniz_games');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('leibniz_games');
    next();
  },
}